import type { FieldProps, TextareaProps } from '@hover/blueprint';
import { Field, Textarea, forwardRef, useMergeRefs } from '@hover/blueprint';
import React from 'react';
import { useFormContext } from 'react-hook-form';

interface TextareaFieldProps
  extends Omit<FieldProps, 'children'>,
    Pick<TextareaProps, 'rows'> {
  rows?: number;
}

const TextareaField = forwardRef<TextareaFieldProps, 'input'>(
  (
    {
      backgroundColor,
      border,
      borderWidth,
      height,
      name,
      placeholder,
      resize,
      rows,
      ...props
    },
    ref,
  ) => {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const { errors, register } = useFormContext<Record<string, string>>();
    const refs = useMergeRefs(ref, register);
    const error = errors[name]?.message;

    return (
      <Field {...props} error={error} name={name} pb={0}>
        <Textarea
          backgroundColor={backgroundColor}
          border={border}
          borderWidth={borderWidth}
          height={height}
          placeholder={placeholder}
          ref={refs}
          resize={resize}
          rows={rows}
          size="default"
        />
      </Field>
    );
  },
);

export { TextareaField };
